import { getFeatureFromSearchParams } from './getFeatureFromSearchParams'
import { getStoredFeature } from './feature.storage'
import type { FeatureEnv } from './feature.types'

/**
 * Resolves the current feature environment on the client side.
 *
 * Priority: URL query param > sessionStorage.
 *
 * Use this wherever a definitive feature value is needed client-side
 * (e.g. injecting x-feature-env into HTTP requests).
 */
export function resolveClientFeature(): FeatureEnv {
  return getFeatureFromSearchParams() ?? getStoredFeature()
}
